import React from "react"
import PropTypes from "prop-types"
import { Flex, Button } from "antd"
import { DeleteOutlined } from "@ant-design/icons"
import { File } from "ui/Icon/DSIcon/File"
import UploadProgress from "../UploadProgress"
import ErrorDisplay from "../ErrorDisplay"
import styles from "../../UploadFile/index.module.css"

/**
 * FilePreview Component
 * Displays the uploaded file with progress, error, and delete functionality
 * Follows Single Responsibility Principle
 */
const FilePreview = ({ file, uploading, uploadComplete, progress, error, onRemove, onErrorClear }) => {
  if (!file) return null

  return (
    <Flex className={styles.filePreview} style={{ width: "100%" }}>
      <div style={{ flex: 1 }}>
        <div className={styles.fileInfo}>
          <File style={{ fontSize: "18px", color: "#1677ff" }} />
          <span className="fileName">{file.name}</span>
        </div>

        <ErrorDisplay error={error} />

        {uploading && !uploadComplete && <UploadProgress progress={progress} />}
      </div>

      {error ? (
        <Button
          type="text"
          shape="circle"
          size="small"
          className={styles.closeIcon}
          onClick={() => {
            onErrorClear()
            onRemove(file)
          }}
          aria-label="Close error message"
          style={{ marginLeft: "16px" }}
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              onErrorClear()
              onRemove(file)
            }
          }}
        >
          &times;
        </Button>
      ) : (
        <div className={styles.rightInfo} style={{ marginLeft: "16px" }}>
          <DeleteOutlined
            onClick={(e) => {
              e.stopPropagation()
              onRemove(file)
            }}
            className={styles.deleteIcon}
          />
        </div>
      )}
    </Flex>
  )
}

FilePreview.propTypes = {
  file: PropTypes.object,
  uploading: PropTypes.bool,
  uploadComplete: PropTypes.bool,
  progress: PropTypes.number,
  error: PropTypes.string,
  onRemove: PropTypes.func.isRequired,
  onErrorClear: PropTypes.func.isRequired
}

export default FilePreview
